'use client'

import Button from '@/components/ui/button'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import { Dialog, DialogContent, DialogFooter, DialogTitle } from '@/components/ui/dialog'
import { useDialog } from '@/components/ui/useDialog'
import { useTranslations } from 'next-intl'
import { cn } from '@/utils/tailwind/utils'
import { useTranslation } from '@/utils/useTranslation'

export function DialogComponent() {
  const t = useTranslations()
  const [translateWithFallback] = useTranslation()
  const { isOpen, close, contentClass = '', title, cancelBtnText, nextBtnText, data } = useDialog()

  const closeText = translateWithFallback(cancelBtnText) || t('Close')
  const nextText = translateWithFallback(nextBtnText) || t('Next')
  const titleText = translateWithFallback(title) || t('Dialog-Title')
  const contentText = translateWithFallback(data) || t('Dialog-Content')

  return (
    <Dialog open={isOpen}>
      <DialogContent aria-describedby="" onOverlayClick={() => close()} showClose={false} className={contentClass}>
        {titleText && <DialogTitle className="pt-8">{titleText}</DialogTitle>}
        {/* <DialogDescription className="invisible absolute">{actionPoint.id}</DialogDescription> */}
        {contentText}
        <DialogFooter className="pt-4">
          {cancelBtnText && (
            <Button color="violet" outlined onClick={() => close()}>
              {closeText}
            </Button>
          )}
          {nextBtnText && <Button onClick={() => close(true)}>{nextText}</Button>}
        </DialogFooter>

        <DialogPrimitive.Close
          className={cn(
            'absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity',
            'hover:opacity-100 disabled:pointer-events-none',
            'data-[state=open]:bg-accent data-[state=open]:text-muted-foreground',
            'focus:outline-none focus:ring-2 focus:ring-slate-100/80 focus:ring-offset-2',
          )}
          onClick={() => close(false)}
        >
          <X className="h-4 w-4" />
          <span className="sr-only">{closeText}</span>
        </DialogPrimitive.Close>
      </DialogContent>
    </Dialog>
  )
}
